// extracted by mini-css-extract-plugin
export var container = "contact-us-tiles-module--container--3b7b6";
export var description = "contact-us-tiles-module--description--7c6b8";
export var icon = "contact-us-tiles-module--icon--efaf8";
export var light = "contact-us-tiles-module--light--7c89a contact-us-tiles-module--tile--27494";
export var tile = "contact-us-tiles-module--tile--27494";
export var title = "contact-us-tiles-module--title--f1e7d";